export enum SkillsFacetsCategories {
  AccentsAndDialects = "Accents & Dialects",
  Languages = "Languages",
  MusicAndDance = "Music & Dance",
  Performance = "Performance",
  Presenting = "Presenting",
  Sports = "Sports",
  VehicleLicences = "Vehicle Licences",
  OtherSkills = "Other Skills",
  VoiceOver = "Voice Over",
}
